import checkmark from "../../assets/checkmark.svg";
import "./Checkmark.scss";

const Checkmark = () => {
  return <img src={checkmark} className="checkmark" alt="checkmark" />;
};

export default Checkmark;
